module.exports = __webpack_public_path__ + "static/media/session.8628adf5.svg";